import _sfc_main from "./component-library126.mjs";
import "./component-library127.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "prices", class: _setup.themeClass }, [_vm.title ? _c(_setup.Heading, { staticClass: "prices__heading", attrs: { "size": "sm", "tag": "h4" } }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c("div", { staticClass: "prices__main" }, [_vm.isPrice ? _c(_setup.Price, { staticClass: "prices__is-price", attrs: { "is-highlight": "", "theme": _vm.theme, "amount": _vm.isPrice, "pre-text": _vm.preTextIsPrice, "post-text": _vm.postTextIsPrice, "variant": _vm.variant, "is-price-bold": _vm.isPriceBold } }) : _vm._e(), _vm._t("footnote"), _vm.wasPrice ? _c(_setup.Price, { staticClass: "prices__was-price", attrs: { "amount": _vm.wasPrice, "is-was-price": "", "pre-text": _vm.preTextWasPrice, "post-text": _vm.postTextWasPrice, "variant": _vm.variant, "theme": _vm.theme, "is-price-bold": _vm.isWasPriceBold } }) : _vm._e()], 2)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d6f82401",
  null,
  null
);
const Prices = __component__.exports;
export {
  Prices as default
};
